module.exports = __webpack_public_path__ + "img/w-virtex@1.5x.955a1b88.png";